import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/login', {
        userkodu: values.userKodu,
        sifre: values.sifre,
      });
      const { token, user } = res.data;
      login(user, token);
      message.success(`Hoş geldiniz, ${user.adSoyad}!`);
      navigate('/dashboard');
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Kullanıcı kodu veya şifre hatalı';
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" bordered={false}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Space direction="vertical" size={4}>
            <img src="/logo.png" alt="DekaPortal" style={{ height: 80, objectFit: 'contain', marginBottom: 8 }} />
            <Title level={2} style={{ margin: 0, color: '#001529' }}>
              DekaPortal
            </Title>
            <Text type="secondary">Gayrimenkul Yönetim Sistemi</Text>
          </Space>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleLogin}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="userKodu"
            label="Kullanıcı Kodu"
            rules={[{ required: true, message: 'Kullanıcı kodunuzu girin' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#bbb' }} />}
              placeholder="Kullanıcı kodunuzu girin"
            />
          </Form.Item>

          <Form.Item
            name="sifre"
            label="Şifre"
            rules={[{ required: true, message: 'Şifrenizi girin' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#bbb' }} />}
              placeholder="Şifrenizi girin"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 44, fontSize: 15 }}
            >
              Giriş Yap
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            © 2024 DekaPortal. Tüm hakları saklıdır.
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default Login;
